import styled from 'styled-components'

import ButtonAsync from '../../../stories/atoms/ButtonAsync/ButtonAsync'
import Heading from '../../../stories/atoms/Heading/Heading'
import Link from '../../../stories/atoms/Link/Link'
import breakpoints from '../../../stories/theme/breakpoints'
import colors from '../../../stories/theme/colors'
import ShoppingCartSolidSvg from '../../../stories/atoms/Icons/General/ShoppingCartSolid'

export const ProductLink = styled(Link)`
  display: block;
  position: relative;

  margin-bottom: 24px;
  padding: 24px;
  border-radius: 4px;

  box-shadow: 2px 4px 12px rgb(0 0 0 / 8%);
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);

  * {
    text-decoration: none !important;
  }

  :hover {
    text-decoration: none !important;
  }

  @media (min-width: ${breakpoints.tablet}) {
    :hover {
      box-shadow: 1px 2px 8px rgb(0 0 0 / 16%);
      transform: scale3d(1.002, 1.002, 1.002);
      text-decoration: none !important;
    }
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`

export const Container = styled.article`
  a {
    background-color: ${colors.Primary.GreyLight};
    border-radius: 5px;
    display: flex;
    padding: 20px 20px 20px 10px;
    border: 1px solid #ebebeb;

    &:hover {
      text-decoration: none;
      border: 1px solid #bdbdbd;
    }
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px 8px 32px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 0 16px 16px 16px;
  }
`

export const Descriptions = styled.ul`
  margin: 0;
  padding: 0 0 0 16px;
  list-style: none;
  padding: 0;

  > li {
    line-height: 24px;
    display: flex;

    > svg {
      min-width: 18px;
      margin-top: 5px;
      margin-right: 10px;
    }
  }
`

export const DesktopBuyProductButton = styled(ButtonAsync)`
  align-self: flex-end;
  display: flex;
  min-width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
  }
`

export const MobileBuyProductButton = styled(ButtonAsync)`
  align-self: flex-end;
  display: flex;
  min-width: fit-content;
`

export const Title = styled(Heading)`
  margin-bottom: 12px;
`

export const MobilePrice = styled(Heading)`
  display: initial;
`

export const DesktopPrice = styled(Heading)`
  display: initial;
  margin-left: 8px;

  @media (max-width: ${breakpoints.tablet}) {
    display: none;
    margin-left: 0;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const MobileFooter = styled.div<{
  alwaysShown: boolean
}>`
  display: none;

  @media (max-width: ${breakpoints.tablet}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  ${({ alwaysShown }) =>
    alwaysShown &&
    `
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  `}
`

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`

export const Image = styled.div<{
  compact: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 88px;
  }

  span {
    display: block;
    font-size: 13px;
    line-height: 24px;
    text-align: center;
  }

  @media (min-width: ${breakpoints.mobile}) {
    ${({ compact }) => !compact && `
      img {
        width: 118px;
      }
    `}
  }
`

export const StyledShoppingCart = styled(ShoppingCartSolidSvg)`
  margin: 0 !important;
`

export const StyledShoppingCardMessage = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
`
